<template>
  <div class="invoice-box">
    <div class="ls-float-left col-md-12 col-xs-12 col-sm-12 col-lg-12 ls-box">
      <h3 class="ls-title">{{ $t('payments.attributes.invoice') }} nº {{ invoiceNumber() }}</h3>
      <p class="ls-title">{{ $t('invoices.attributes.due') + date.parseDate(invoice.due_date) }}</p>
      <hr class="ls-no-margin-bottom">

      <div v-if="invoice.invoice_items" class="box-scroll">
        <div v-for="(invoice_item, index) in invoice.invoice_items.filter(item => item.active)">
          <p class="main-text">{{ invoice_item.description }}</p>
          <p v-if="showItemType()">{{ invoice_item.resource_label }}</p>
          <p>{{ validity(invoice_item) }}</p>
          <p>R${{ money.parseViewValue(invoice_item.price) }}</p>
          <hr v-if="index < invoice.invoice_items.length - 1" class="ls-no-margin-top">
        </div>
      </div>

      <hr class="ls-no-margin-top">
      <span class="ls-md-margin-top">{{ $t('payments.attributes.amount_due') }}: R$ {{ money.parseViewValue(invoice.amount_due) }}</span>
    </div>
  </div>
</template>
<script>
  import money from 'src/utils/money'
  import date from 'src/utils/date'

  export default {
    name: 'invoice-details',
    props: ['invoice'],
    data () {
      return {
        money: money,
        date: date,
        copySucceeded: null
      }
    },
    methods: {
      validity (invoiceItem) {
        if (!invoiceItem.from || !invoiceItem.till) return
        var from = date.parseDate(invoiceItem.from)
        var till = date.parseDate(invoiceItem.till)
        return from + ' - ' + till
      },
      openBillet () {
        window.open(this.invoice.order.payment_url, '', 'resizable')
      },
      copyToClipBoard () {
        this.$refs.barCode.select()
        document.execCommand('copy')
        document.getSelection().removeAllRanges()

        setTimeout(this.disableCopy, 2000)
        this.enableCopy()
      },
      trayAccount () {
        return window.location.host.split('.')[0] === 'tray'
      },
      showItemType () {
        if (this.invoice.contract_id !== null) return true

        return false
      },
      invoiceNumber () {
        if (this.trayAccount() && this.invoice.code) return this.invoice.code
        return this.invoice.identifier
      }
    },
    computed: {
      barCode () {
        return 'this.invoice.order.billet_bar_code'
      }
    }
  }
</script>
<style lang="scss" scoped>
  .invoice-box {
    height: 200px;
  }
  .box-scroll {
    overflow-y: auto;
    max-height: 250px;
  }
  .main-text {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// InvoiceDetails.vue?16027a04